import { mutator } from 'satcheljs';
import getStore from '../store/store';
import deleteService from '../actions/deleteService';

/**
 * Delete a service from the store.
 */
export default mutator(deleteService, actionMessage => {
    let store = getStore();

    // The delete service command operates on itemId and not
    // serviceId. The internal data structures are all centered
    // around the serviceId.
    store.services.forEach(service => {
        if (service.ItemId.Id === actionMessage.itemId.Id) {
            const serviceIdToDelete = service.ServiceId;
            store.services.delete(serviceIdToDelete);
            const index = store.servicesOrder.indexOf(serviceIdToDelete);
            store.servicesOrder.splice(index, 1);
            return;
        }
    });
});
